module.exports = __webpack_public_path__ + "img/select-panel.f5d46ed2.svg";